import * as React from "react";
import {  useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useGlobalAuthContext } from "../context/AuthContext";
import { useDispatch } from "react-redux";
import { login } from "../Slices/roomNateSlice";
import Cookies from "js-cookie";
import Loader from "../Components/loader";
import Box from "@mui/material/Box";


export default function PartnerLogin() {

  const {  dispatch } = useGlobalAuthContext();
  const location = useLocation();


  const navigate = useNavigate();
  const Dispatch = useDispatch();

 

  React.useEffect(() => {
    const queryParams = new URLSearchParams(location.search);

    const token = queryParams.get('token');
    const rememberMe = queryParams.get('rememberMe');

    dispatch({ type: "LOGIN", payload: token });

    if (rememberMe) {
      Cookies.set("token", JSON.stringify(token), {
        expires: 30,
      });
    } else {
      Cookies.set("token", JSON.stringify(token), {
        expires: 7,
      });
    }

    Dispatch(login(token));
    navigate("/main");

  }, [Dispatch, dispatch, location.search, navigate]);

 return (
  <Box sx={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh'
  }}>
    <Loader /> 
  </Box>
 )

}
